export default __webpack_public_path__ + "static/media/hexagon.723afa97.svg";